import Navbar from './Components/Navbar/Navbar';
import Main from './Components/Main/Main';
import About from './Components/About/About';
import Projects from './Components/Projects/Project'
import Experiance from './Components/Experience/Experience';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <div>
      <Navbar />
      <Main />
      <About />
      <Projects />
      <Experiance />
      <Footer />
    </div>
  );
}

export default App;

